document.addEventListener('DOMContentLoaded', function() {
 
    var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      // Don't prevent the default form submission
      // Shopify will handle adding the item to the cart

      // Get the product details
      var productId = form.querySelector('[name="id"]').value;
      var quantity = form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1;

      var price = 0;
      var priceElement;

      // Check if we're on a collection page (multiple products)
      if (document.querySelector('.card__content')) {
        // Collection page logic
        var cardContent = form.closest('.card__content');
        if (cardContent) {
          priceElement = cardContent.querySelector('.price-item.price-item--sale.price-item--last');
        }
      } else {
        // Product page logic
        priceElement = document.querySelector('.price-item.price-item--sale.price-item--last');
      }

      if (priceElement) {
        // Extract the price from the element's text content
        var priceText = priceElement.textContent.trim();
        // Remove currency symbol and 'USD', then parse as float
        price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        //console.log('Price extracted:', price);
      } else {
        //console.error('Price element not found for product ID:', productId);
      }

      //console.log('Product added:', { id: productId, quantity: quantity, price: price });

      // Trigger Google Ads conversion
      gtag('event', 'conversion', {
        'send_to': 'AW-773317597/dj8mCKmwr9cBEN3H3_AC',
        'value': price * quantity,
        'currency': 'USD',
      });
    });
  });
});